import { Injectable } from "@angular/core";
import { Observable, catchError, map, switchMap, tap, throwError, timeout } from 'rxjs';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { CarnetImgModel, CarnetModel, CarnetRequestModel } from "../../models/carnet";
import { environment as ENV } from '../../../environments/environment';
import { URL_MAP } from "../../shared/urlMap";

@Injectable({
  providedIn: 'root'
})
export class CarnetService {
  HOST = ENV.HOST;
  API = URL_MAP.API;

  constructor(
    private httpClient: HttpClient,
  ) { }
  
  public carnetData(json: CarnetModel): Observable<any> {   
    var jsonParametros = { 
      "prm_docu_tipo": json.typeDocument,
      "prm_docu_nro": json.identification.toString(),
      "prm_docu_asesor": json.identificationAsesor,
      "prm_tipo_asesor": json.typeAsesor
    };        
    const httpOptions = {
      headers: new HttpHeaders({
        'Accept': "*/*"            
      })
    };
    return this.httpClient.post(`${this.HOST}${this.API.GETCARNETAFILIADOS}`, jsonParametros, httpOptions);  
  }
  
  public carnetImage(json: CarnetImgModel, action: 'generate' | 'send' = 'generate'): Observable<any> {  
    const jsonParametros: any = { "prm_programa": json.planCarnet };
    jsonParametros._trackingAction = action;  
    const httpOptions = {
      headers: new HttpHeaders({
        'Accept': "*/*"
      })
    };
    return this.httpClient.post(`${this.HOST}${this.API.GETCARNET}`, jsonParametros, httpOptions).pipe(timeout(6000));      
  }  
}